import React, { FC } from 'react';
import { useField } from 'formik';
import { RequiredNameProps } from 'common/types/utility';
import {
  ComboBox,
  IComboBoxProps,
  SelectableOptionMenuItemType,
} from '@fluentui/react';

export const FormikComboBox: FC<RequiredNameProps<IComboBoxProps>> = ({
  name,
  onChange,
  ...props
}) => {
  const [field, meta, helpers] = useField<
    | string
    | number
    | { [key: string]: boolean | null | undefined }
    | undefined
    | null
  >(name);
  const { value: fieldValue } = field;

  if (fieldValue && typeof fieldValue === 'object') {
    const selectAllOption = props.options.find(
      (opt) => opt.itemType === SelectableOptionMenuItemType.SelectAll
    );
    const numOptions = selectAllOption
      ? props.options.length - 1
      : props.options.length;
    const selectedKeys = props.options
      .map((opt) => opt.key as string)
      .filter((key) => fieldValue[key]);
    const allSelected = selectedKeys.length === numOptions;

    return (
      <ComboBox
        {...props}
        errorMessage={meta.error}
        selectedKey={[
          ...(allSelected && selectAllOption
            ? [selectAllOption.key as string]
            : []),
          ...selectedKeys,
        ]}
        onChange={(event, option, index, value) => {
          if (option) {
            const newValueObject =
              option.itemType === SelectableOptionMenuItemType.SelectAll
                ? Object.fromEntries(
                  Object.keys(fieldValue).map((key) => [key, !allSelected])
                )
                : { ...fieldValue, [option.key]: option.selected };

            helpers.setValue(newValueObject);
          }

          onChange?.(event, option, index, value);
        }}
      />
    );
  } else
    return (
      <ComboBox
        {...props}
        errorMessage={meta.error}
        selectedKey={fieldValue}
        onChange={(event, option, index) => {
          helpers.setValue(option?.key);
          onChange?.(event, option, index);
        }}
      />
    );
};
